class Product {
  constructor() {
    this.productReview = document.querySelector(".product__review");
    this.addToCartBtn = document.querySelector(".product-form__submit");
    this.stickyATC = document.querySelector(".pdp-sticky");
    this.toggleElement = document.querySelector("[data-select-toggle]");
    this.optionsElement = document.querySelector("[data-select-options]");

    this.init();

    this.initializeCompleteTheLookDesktopSplide();
    this.initializeCompleteTheLookMobileSplide();
  }

  init() {
    this.productReview?.addEventListener("click", this.scrollProductReview.bind(this));
    this.toggleElement?.addEventListener("click", (event) => {
      event.stopPropagation();
      this.toggleDropdown();
    });
    document.addEventListener("click", (event) => {
      if (!this.optionsElement) return;
      if (!this.toggleElement?.contains(event.target) && !this.optionsElement.contains(event.target)) {
        this.optionsElement.style.display = "none";
      }
    });

    // Observe the add-to-cart button for sticky ATC
    this.observeAddToCart();
    this.initializeSelectSizePrompt();
  }

  // Scroll to product review section
  scrollProductReview() {
    let productReview = document.getElementById("product__review");
    if (!productReview) return;
    setTimeout(() => {
      productReview.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 50);
  }

  // Toggle dropdown visibility
  toggleDropdown() {
    if (this.optionsElement.style.display === "none" || this.optionsElement.style.display === "") {
      this.optionsElement.style.display = "block";
    } else {
      this.optionsElement.style.display = "none";
    }
  }

  // Toggle sticky Add to Cart button visibility
  toggleStickyATC(isVisible) {
    if (!this.stickyATC) return;
    this.stickyATC.style.transform = isVisible ? "translateY(100%)" : "translateY(0)";
  }

  // Observe Add to Cart button visibility and toggle sticky ATC
  observeAddToCart() {
    const isGridGallery = Boolean(document.querySelector(".product--grid-gallery"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.toggleStickyATC(true);
            if (this.optionsElement) this.optionsElement.style.display = "none";
            return;
          }

          // Grid-gallery mobile: only show sticky ATC after scrolling past the main button
          const isMobile = window.matchMedia("(max-width: 749px)").matches;
          if (isGridGallery && isMobile && entry.boundingClientRect.top > 0) {
            this.toggleStickyATC(true);
            return;
          }

          this.toggleStickyATC(false);
        });
      },
      { threshold: 0 }
    );

    if (this.addToCartBtn) {
      observer.observe(this.addToCartBtn);
    }
  }

  initializeSelectSizePrompt() {
    if (!this.hasMultipleVariants()) return;

    const soldOutText = window.variantStrings?.soldOut || "SOLD OUT";
    const selectASizeText = window.variantStrings?.selectASize || "SELECT A SIZE";

    document.querySelectorAll(".product-form__submit").forEach((button) => {
      const label = button.querySelector("span");
      if (!label) return;
      if (label.textContent.trim() === soldOutText) return;

      button.disabled = true;
      label.textContent = selectASizeText;
    });
  }

  hasMultipleVariants() {
    return Boolean(document.querySelector('product-form[data-has-multiple-variants="true"]'));
  }

  // initialize the complete the look
  initializeCompleteTheLookDesktopSplide() {
    // Grid-gallery below uses CSS scroll-snap instead of Splide
    if (document.querySelector("#splide-complete-the-look-below")) return;

    const target = document.querySelector("#splide-complete-the-look-desktop");
    if (!target) return;

    new Splide(target, {
      type: "slide",
      gap: 18,
      perPage: 4,
      arrows: false,
      perMove: 1,
      lazyLoad: "sequential",
      breakpoints: {
        1280: { perPage: 3 },
        768: { perPage: 2 },
      },
    }).mount();
  }

  // initialize the complete the look mobile
  initializeCompleteTheLookMobileSplide() {
    // Grid-gallery uses CSS scroll-snap on #splide-complete-the-look-below
    if (document.querySelector("#splide-complete-the-look-below")) return;

    const target = document.querySelector("#splide-complete-the-look-mobile");
    if (!target) return;

    new Splide(target, {
      type: "slide",
      gap: 18,
      perPage: 4,
      arrows: false,
      perMove: 1,
      lazyLoad: "sequential",
      breakpoints: {
        1280: { perPage: 3 },
        768: { perPage: 2 },
      },
    }).mount();
  }
}

// Initialize Product class on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
  new Product();
});
